// @flow

import { type Fx  } from '../types';

export function isLocalFx(fx: Fx): bool {
  return fx['from'] === fx['to'];
}
